import { render, staticRenderFns } from "./PosterGeneralInfo.vue?vue&type=template&id=aef8388a&scoped=true"
import script from "./PosterGeneralInfo.vue?vue&type=script&lang=js"
export * from "./PosterGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./PosterGeneralInfo.vue?vue&type=style&index=0&id=aef8388a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef8388a",
  null
  
)

export default component.exports